/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ManagerTypeResponse = {
    SalesManager: 'SALES_MANAGER',
    CommunityManager: 'COMMUNITY_MANAGER',
    CountryManager: 'COUNTRY_MANAGER'
} as const;
export type ManagerTypeResponse = typeof ManagerTypeResponse[keyof typeof ManagerTypeResponse];


export function instanceOfManagerTypeResponse(value: any): boolean {
    for (const key in ManagerTypeResponse) {
        if (Object.prototype.hasOwnProperty.call(ManagerTypeResponse, key)) {
            // @ts-ignore
            if (ManagerTypeResponse[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ManagerTypeResponseFromJSON(json: any): ManagerTypeResponse {
    return ManagerTypeResponseFromJSONTyped(json, false);
}

export function ManagerTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerTypeResponse {
    return json as ManagerTypeResponse;
}

export function ManagerTypeResponseToJSON(value?: ManagerTypeResponse | null): any {
    return value as any;
}

